import { companyName } from "muminsmart-utils";

const Footer = () => {
  return (
    <div>
      <p className="text-center text-sm text-gray-400 mb-5">
        © {new Date().getFullYear()} Mumin&apos;s Mart. A product of{" "}
        {companyName}.
      </p>
    </div>
  );
};
export default Footer;
